module.exports = __webpack_public_path__ + "static/media/aquarius-redpeach.eedcd036.jpg";